module.exports = __webpack_public_path__ + "static/media/ie.e88a1541.svg";